import { useState } from "react";
import { useTenant } from "@/tenant/TenantProvider";
import { mediaUrl } from "@/lib/api";
import { TENANT } from "@/constants/testIds";

/**
 * The restaurant's mark in the header: its uploaded logo, or its initial on a
 * dark tile until one exists.
 *
 * `branding.logo_url` is absent for most restaurants and for a while after
 * onboarding, so the letter tile is the normal state, not an error state — the
 * same rule dish photos follow in DishThumb. `alt=""` because the restaurant's
 * name already sits next to this as text; a screen reader gains nothing from
 * hearing it twice.
 */
const TenantMark = () => {
  const { restaurant } = useTenant();
  const [failed, setFailed] = useState(false);
  const src = !failed && restaurant.branding?.logo_url ? mediaUrl(restaurant.branding.logo_url) : null;
  const initial = (restaurant.name || "?").trim().charAt(0).toUpperCase();

  if (src) {
    return (
      <img
        data-testid={TENANT.mark}
        src={src}
        alt=""
        onError={() => setFailed(true)}
        className="w-11 h-11 rounded-xl object-cover bg-neutral-900 shrink-0"
      />
    );
  }

  return (
    <div
      data-testid={TENANT.markInitials}
      className="w-11 h-11 rounded-xl bg-neutral-900 text-white flex items-center justify-center font-black shrink-0"
    >
      {initial}
    </div>
  );
};

export default TenantMark;
